import { PARAMETERART_FRACHT, PARAMETERART_KONZENTRATION, PARAMETERART_MENGE } from "../../../../consts/anforderungParameterart";

export const filteredAnforderungen = (anforderungen, anforderungArt) => {
    return {
        [PARAMETERART_KONZENTRATION]: anforderungen.filter(
            (a) => a.anforderungArt.id === anforderungArt && a.parameterArt && a.parameterArt.id === PARAMETERART_KONZENTRATION
        ),
        [PARAMETERART_FRACHT]: anforderungen.filter(
            (a) => a.anforderungArt.id === anforderungArt && a.parameterArt && a.parameterArt.id === PARAMETERART_FRACHT
        ),
        [PARAMETERART_MENGE]: anforderungen.filter(
            (a) => a.anforderungArt.id === anforderungArt && a.parameterArt && a.parameterArt.id === PARAMETERART_MENGE
        ),
    };
};
